import React from "react";
import AppBar from "@material-ui/core/AppBar";
import { withStyles } from "@material-ui/core/styles";
import { Paper } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import Toolbar from "@material-ui/core/Toolbar";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import IconButton from "@material-ui/core/IconButton";
import Button from '@material-ui/core/Button';


import InputBase from '@material-ui/core/InputBase';
import { fade } from '@material-ui/core/styles/colorManipulator';

import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';

import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete"
import CallIcon from "@material-ui/icons/Call";
import Divider from "@material-ui/core/Divider";
import _ from "lodash";
import getData from "./../../data-services/api";
import Loader from "./../../components/CustomLoader";
import client from "./../../utils/apolloClient";
import { getUser } from "./../../data-services/queries";
import gql from "graphql-tag";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';


const styles = theme => ({
  fab: {
    //   margin: theme.spacing.unit,
    position: "fixed",
    right: 0,
    bottom: 0,
    margin: "20px"
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,    
  },
  title: {
    display: 'none',
    marginLeft:0,
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
    
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginLeft: 20,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing.unit,
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing.unit * 7,
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
    width: '100%',
  },
  inputInput: {
    paddingTop: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 7,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: 120,
      '&:focus': {
        width: 200,
      },
    },
  }
});

class ListOutlet extends React.Component {
  state = {
    loading: true,
    noResult:false,
    dialogOpen:false,
  };

  async componentDidMount() {
    await client
      .query({
        query: gql(getUser)
      })
      .then(({ data }) => {
        if (data.user.role === "CMDI") {
          this.setState({
            userData: data.user
          });
        }
      });
    if (this.state.userData && this.state.userData.sfid) {
      Promise.all([
        getData(
          `select id, outletName__c,Outletcode__c,Mobile_No__c,Address__c,Region__c,State__c,District__c,WSS_Name__c,WSS_CODE__c,WSS_Phone__c,TTY_Name__c,TTY_Code__c,TSI_TTY_Phone__c,Cluster__c,Cluster_BM_Mobile_no__c,CMDI_Name__c,Cluster_Code__c,Cluster__c from  Salesforce.outlets__c where CMDI_Name__c like '${
            this.state.userData.sfid
          }'`
        )
        // getData(
        //   `select outletName__c,Outletcode__c,Mobile_No__c,Address__c,WSS_Name__c,WSS_CODE__c,WSS_Phone__c,TTY_Name__c,TTY_Code__c,TSI_TTY_Phone__c,Cluster__c,Cluster_BM_Mobile_no__c,CMDI_Name__c from  Salesforce.outlets__c limit 5 `
        // )
      ]).then(([outlets, ...data]) => {
        this.setState({
          outlets: outlets.result,
          loading: false
        });
      });
    }
  }

  handleDialogClickOpen = (outletid) => {
    this.setState({ dialogOpen: true, deleteOutletid:outletid });
  };

  handleDialogClose = async decision => {
    if(decision===true){
      const response = await getData(`delete from Salesforce.outlets__c Where cmdi_name__c = '${this.state.userData.sfid}' and id='${this.state.deleteOutletid}'`)
    if(response){
      const outlets = this.state.outlets.filter(outlet=> outlet.id!== this.state.deleteOutletid)
      this.setState({
        outlets:outlets,
      })      
    }
    }
    this.setState({ dialogOpen: false });
    
  };

  filterList = (item) =>{  
    console.log('item', item)      
      if (item.length > 2) {
        this.setState({
          noResult:false,    
          loading:true
        })
        if (this.state.userData && this.state.userData.sfid) {
          const query = `select id, outletName__c,Outletcode__c,Mobile_No__c,Address__c,Region__c,State__c,District__c,WSS_Name__c,WSS_CODE__c,TTY_Name__c,TTY_Code__c from  Salesforce.outlets__c where CMDI_Name__c like '${
            this.state.userData.sfid
          }' and (outletName__c ilike '%${item}%' or Outletcode__c ilike '%${item}%')`;
          getData(query)
            .then(r => {
              r.result ?  this.setState({
                outlets:r.result,
                loading:false
              }):  this.setState({    
                noResult:true,            
                loading:false
              });             
            })
            .catch(e => {              
              
            });
        }
      } else if(item.length === 0) {
        this.setState({    
          noResult:false,            
          loading:false
        }); 
      }    
  }

  

  render() {
    const { classes, history } = this.props;
    const { outlets } = this.state;

    return (
      <div>
         <AppBar position="static">
        <Toolbar>
        <IconButton
              className={classes.menuButton}
              color="inherit"
              aria-label="Menu"
              onClick={() => {
                history.goBack();
              }}
            >
              <ArrowBackIcon />              
            </IconButton>
            <Typography
              variant="title"
              color="inherit"              
            >
              Outlets
            </Typography>
          
          <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
            <InputBase
              placeholder="Search…"
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              onInput={(e)=>{
                this.filterList(e.target.value);
              }}              
            />
          </div>
        </Toolbar>
      </AppBar>
        {/* <AppBar position="static">
          <Toolbar>
            <IconButton
              className={classes.menuButton}
              color="inherit"
              aria-label="Menu"
              onClick={() => {
                history.goBack();
              }}
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography
              variant="title"
              color="inherit"
              className={classes.flex}
            >
              Outlets
            </Typography>

          </Toolbar>
        </AppBar> */}
        {this.state.noResult?  <Grid container alignItems="center" justify="center">
            <Typography variant="h6" >No result found</Typography>
          </Grid>:this.state.loading ? (
          <Grid container alignItems="center" justify="center">
            <Loader type="Audio" color="#00BFFF" height="50" width="50" />
          </Grid>
        ) : (
          <div>
            <List>
              <Paper>
                {outlets ? (
                  outlets.map(outlet => {
                    return (
                      <div key={outlet.id}>
                        <Divider />
                        <Grid
                          container
                          justify="space-between"
                          alignItems="center"
                          style={{ padding: 10 }}
                        >
                          <Grid container alignItems="center">
                            <Grid
                              item
                              xs={8}
                              onClick={() => {
                                history.push({
                                  pathname: "/addEditOutlet",
                                  search: `?outletid=${outlet.id}`
                                });
                              }}
                            >
                              <Grid item xs={12}>
                                <Typography variant="subtitle2">
                                  {outlet.outletcode__c} {" - "}
                                  {outlet.outletname__c}
                                </Typography>{" "}
                              </Grid>
                              <Grid item xs={12}>
                                <Typography variant="caption">
                                  {outlet.wss_name__c} {outlet.address__c}
                                </Typography>{" "}
                              </Grid>
                            </Grid>
                            <Grid item xs={2}>
                              {outlet.mobile_no__c ? (
                                <a href={"tel:" + outlet.mobile_no__c}>
                                  <IconButton>
                                    <CallIcon color="primary" />
                                  </IconButton>
                                </a>
                              ) : null}
                            </Grid>
                            <Grid item xs={2}>                             
                                  <IconButton>
                                    <DeleteIcon color="error"  onClick={()=>this.handleDialogClickOpen(outlet.id)}/>
                                  </IconButton>                                
                            </Grid>                            
                          </Grid>
                        </Grid>
                      </div>
                    );
                  })
                ) : (
                  <Grid
                    container
                    spacing={8}
                    justify="center"
                    alignItems="center"
                  >
                    <Grid item>
                      <Typography align="center" variant="h6">
                        No Record Present
                      </Typography>
                    </Grid>
                  </Grid>
                )}
              </Paper>
            </List>
          </div>
        )}
        
        <Fab
          color="primary"
          aria-label="Add"
          onClick={() => {
            history.push("/addEditOutlet");
          }}
          className={classes.fab}
        >
          <AddIcon />
        </Fab>

        <Dialog
          open={this.state.dialogOpen}
          onClose={this.handleDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Are you sure?"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              You want to delete this outlet? 
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={()=>this.handleDialogClose(false)} color="primary">
              No
            </Button>
            <Button onClick={()=>this.handleDialogClose(true)} color="primary" autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withRouter(withStyles(styles)(ListOutlet));
